import tagTester from './_tagTester.js';

export default tagTester('Symbol');



//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/isSymbol.js
// module id = 568
// module chunks = 9